export const FETCH_AVAILABLE_JOURNEYS = "/journeys";
export const UPDATE_USER_JOURNEY = "/iam/v2/users/profile/journeys";